/**
 * Build-time configuration. Everything here is compiled into the public bundle —
 * never put a secret in a `VITE_*` variable.
 */
export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '/api/v1/admin',
  appName: import.meta.env.VITE_APP_NAME || 'Anitra BovID',
} as const;
